import * as localizations from './contentLocalization';
export const appStrings = localizations;
